import { EnvironmentModel } from "./environmentModel";

export const environment: EnvironmentModel = {
  EnvironmentName: "Dev",
  production: false,
  zisApiBaseUrl: "https://zenithapi-devtest.zis.com/api/",
  cookieDomain: ".zis.com",
  approvalsUrl: "https://approval-devtest.zis.com/",
};
